import { IconProps } from ".";

export const USDIcon: React.FC<IconProps> = (props) => {
  return (
    <svg viewBox="0 0 53 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.488 13.364C16.488 15.686 15.192 17 12.87 17H4.77C2.448 17 1.134 15.686 1.134 13.364V4.706C1.134 4.508 1.242 4.4 1.458 4.4H2.196C2.394 4.4 2.502 4.508 2.502 4.706V13.274C2.502 14.912 3.384 15.812 5.022 15.812H12.6C14.238 15.812 15.138 14.912 15.138 13.274V4.706C15.138 4.508 15.246 4.4 15.444 4.4H16.182C16.38 4.4 16.488 4.508 16.488 4.706V13.364ZM22.3104 5.588C20.5464 5.588 19.7904 6.182 19.7904 7.64V8.072C19.7904 9.512 20.5464 10.106 22.3104 10.106H29.9964C32.3364 10.106 33.7764 10.916 33.7764 13.202V13.886C33.7764 16.19 32.3364 17 29.9964 17H18.9624C18.7464 17 18.6384 16.892 18.6384 16.694V16.118C18.6384 15.92 18.7464 15.812 18.9624 15.812H29.8884C31.6524 15.812 32.4084 15.218 32.4084 13.76V13.328C32.4084 11.888 31.6524 11.294 29.8884 11.294H22.2024C19.8624 11.294 18.4224 10.484 18.4224 8.198V7.514C18.4224 5.21 19.8624 4.4 22.2024 4.4H33.0924C33.2904 4.4 33.3984 4.508 33.3984 4.706V5.282C33.3984 5.48 33.2904 5.588 33.0924 5.588H22.3104ZM35.765 4.706C35.765 4.508 35.873 4.4 36.071 4.4H46.979C49.715 4.4 51.173 5.912 51.173 8.594V12.806C51.173 15.488 49.715 17 46.979 17H36.071C35.873 17 35.765 16.892 35.765 16.694V4.706ZM49.823 12.734V8.666C49.823 6.668 48.743 5.588 46.709 5.588H37.133V15.812H46.709C48.743 15.812 49.823 14.732 49.823 12.734Z"
        fill="url(#paint0_linear_12410_25960)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12410_25960"
          x1="-3.84323"
          y1="3.93959"
          x2="37.2719"
          y2="3.93959"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A7A9AC" style={{ stopColor: "#A7A9AC", stopOpacity: "1" }} />
          <stop
            offset="0.0091653"
            stopColor="#AAACAF"
            style={{ stopColor: "#AAACAF", stopOpacity: "1" }}
          />
          <stop
            offset="0.1095"
            stopColor="#C9CACC"
            style={{ stopColor: "#C9CACC", stopOpacity: "1" }}
          />
          <stop
            offset="0.203"
            stopColor="#DFE0E1"
            style={{ stopColor: "#DFE0E1", stopOpacity: "1" }}
          />
          <stop
            offset="0.2859"
            stopColor="#ECEDEE"
            style={{ stopColor: "#ECEDEE", stopOpacity: "1" }}
          />
          <stop
            offset="0.35"
            stopColor="#F1F2F2"
            style={{ stopColor: "#F1F2F2", stopOpacity: "1" }}
          />
          <stop
            offset="0.4681"
            stopColor="#EAEBEC"
            style={{ stopColor: "#EAEBEC", stopOpacity: "1" }}
          />
          <stop
            offset="0.6561"
            stopColor="#D7D8DA"
            style={{ stopColor: "#D7D8DA", stopOpacity: "1" }}
          />
          <stop
            offset="0.8892"
            stopColor="#B8BABC"
            style={{ stopColor: "#B8BABC", stopOpacity: "1" }}
          />
          <stop offset="1" stopColor="#A7A9AC" style={{ stopColor: "#A7A9AC", stopOpacity: "1" }} />
        </linearGradient>
      </defs>
    </svg>
  );
};
